export const LINK_ORDER_PACKAGE = {
    REQUEST: 'PACKAGE.FORM_LINK_ORDER_PACKAGE.LINK_ORDER_PACKAGE.REQUEST',
    SUCCESS: 'PACKAGE.FORM_LINK_ORDER_PACKAGE.LINK_ORDER_PACKAGE.SUCCESS',
    FAILED: 'PACKAGE.FORM_LINK_ORDER_PACKAGE.LINK_ORDER_PACKAGE.FAILED',
};

export const CLEAR_STATE = 'PACKAGE.FORM_LINK_ORDER_PACKAGE.CLEAR_STATE';
